<template>
    <v-container fluid>
      <v-card class="mb-4">
        <v-card-title>Monthly Income Statement</v-card-title>
        <v-card-text v-for="item in incomeStatement" :key="item.month">
          <h3>{{ item.month }}</h3>
          <v-row>
            <v-col cols="6">
              <p><strong>Rental Income:</strong> {{ format(item.rental_income) }}</p>
              <p><strong>Late Fees:</strong> {{ format(item.late_fees) }}</p>
              <p><strong>Other Income:</strong> {{ format(item.other_income) }}</p>
            </v-col>
            <v-col cols="6">
              <p><strong>Expenses:</strong></p>
              <ul>
                <li v-for="(value, category) in item.expenses" :key="category">
                  {{ category }}: {{ format(value) }}
                </li>
              </ul>
              <p><strong>Total Expenses:</strong> {{ format(item.total_expenses) }}</p>
            </v-col>
          </v-row>
          <v-alert type="info">Net Operating Income: {{ format(item.net_income) }}</v-alert>
          <v-divider class="my-4"></v-divider>
        </v-card-text>
      </v-card>
  
      <v-card>
        <v-card-title>Cash Flow Statement</v-card-title>
        <v-card-text v-for="item in cashFlow" :key="item.month">
          <h3>{{ item.month }}</h3>
          <v-row>
            <v-col cols="6">
              <p><strong>Cash Inflows:</strong></p>
              <ul>
                <li v-for="(value, type) in item.inflows" :key="type">
                  {{ type }}: {{ format(value) }}
                </li>
              </ul>
              <p><strong>Total Inflow:</strong> {{ format(item.total_inflow) }}</p>
            </v-col>
            <v-col cols="6">
              <p><strong>Cash Outflows:</strong></p>
              <ul>
                <li v-for="(value, type) in item.outflows" :key="type">
                  {{ type }}: {{ format(value) }}
                </li>
              </ul>
              <p><strong>Total Outflow:</strong> {{ format(item.total_outflow) }}</p>
            </v-col>
          </v-row>
          <v-alert type="info">
            Opening: {{ format(item.opening_balance) }} | 
            Closing: {{ format(item.closing_balance) }}
          </v-alert>
          <v-divider class="my-4"></v-divider>
        </v-card-text>
      </v-card>
    </v-container>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
//   import axios from 'axios'
import apiClient from '@/services/api';
  
  const incomeStatement = ref([])
  const cashFlow = ref([])
  
  const format = (val) => new Intl.NumberFormat().format(val || 0)
  
  onMounted(async () => {
    const incomeRes = await apiClient.get('/income-statement')
    incomeStatement.value = incomeRes.data
  
    const flowRes = await apiClient.get('/cash-flow')
    cashFlow.value = flowRes.data
  })
  </script>
  